// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1AUn0","clinicsSelect":"TableHeading_clinicsSelect__2oY7k"};